import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagEC = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25l-25 2.174L0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M3.345 37.5C7.668 44.971 15.746 50 25 50c9.253 0 17.332-5.028 21.654-12.5L25 35.868l-21.655 1.63Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M46.655 37.5A24.885 24.885 0 0 0 50 25H0c0 4.554 1.218 8.823 3.345 12.5h43.31Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 33.696a8.696 8.696 0 1 0 0-17.392 8.696 8.696 0 0 0 0 17.392Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 30.435A5.44 5.44 0 0 1 19.566 25v-3.26A5.44 5.44 0 0 1 25 16.303a5.441 5.441 0 0 1 5.435 5.435V25A5.44 5.44 0 0 1 25 30.436Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M33.695 11.957h-6.521a2.174 2.174 0 0 0-4.348 0h-6.522c0 1.2 1.046 2.174 2.246 2.174h-.072c0 1.2.973 2.174 2.174 2.174 0 1.2.973 2.174 2.174 2.174h4.348c1.2 0 2.174-.973 2.174-2.174 1.2 0 2.174-.973 2.174-2.174h-.073c1.2 0 2.246-.973 2.246-2.174Z"
}));
FlagEC.displayName = 'FlagEC';
export default withFlagWrapper(FlagEC);
//# sourceMappingURL=index.js.map